var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "announcement-popup" }, [
    _vm.showListPane
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "list-pane",
          },
          [
            _vm.list.length
              ? _c(
                  "ul",
                  { staticClass: "notice-list" },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.id,
                        staticClass: "notice-item",
                        class: { active: _vm.selectedId === item.id },
                        on: {
                          click: function ($event) {
                            return _vm.handleSelect(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "notice-item__head" }, [
                          item.is_unread
                            ? _c("i", { staticClass: "status-dot" })
                            : _vm._e(),
                          _c("span", { staticClass: "notice-title" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "notice-item__meta" },
                          [
                            item.tag
                              ? _c(
                                  "el-tag",
                                  {
                                    style: _vm.tagStyle(item.tag.color),
                                    attrs: { size: "mini", effect: "plain" },
                                  },
                                  [_vm._v(_vm._s(item.tag.name))]
                                )
                              : _vm._e(),
                            item.creator_name
                              ? _c("span", { staticClass: "meta-sep" }, [
                                  _vm._v(_vm._s(item.creator_name)),
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "meta-sep" }, [
                              _vm._v(_vm._s(item.audit_time || "")),
                            ]),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                )
              : !_vm.listLoading
              ? _c("div", { staticClass: "pane-empty" }, [_vm._v("暂无公告")])
              : _vm._e(),
            _vm.pages.totalCount
              ? _c(
                  "div",
                  { staticClass: "list-footer" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        small: "",
                        background: "",
                        layout: "total, prev, pager, next",
                        "page-size": _vm.pagesize,
                        total: _vm.pages.totalCount,
                        "current-page": _vm.pages.currentPage,
                      },
                      on: { "current-change": _vm.handleCurrentChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.detailLoading,
            expression: "detailLoading",
          },
        ],
        staticClass: "detail-pane",
        class: { "detail-pane--full": !_vm.showListPane },
      },
      [
        _vm.detail.id
          ? _c(
              "div",
              { staticClass: "content-title" },
              [
                _vm._v(" " + _vm._s(_vm.detail.title) + " "),
                _vm.showCallbackBar && !_vm.callbackDone
                  ? _c(
                      "el-tag",
                      { staticClass: "callback-tag", attrs: { size: "mini" } },
                      [_vm._v("待回执")]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "detail-scroll" },
          [
            _vm.detail.id
              ? [
                  _vm.showCallbackBar
                    ? _c("div", { staticClass: "callback-bar" }, [
                        _vm._m(0),
                        _c(
                          "div",
                          { staticClass: "callback-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  loading: _vm.callbackLoading,
                                  disabled: _vm.callbackDone,
                                },
                                on: { click: _vm.handleCallback },
                              },
                              [_vm._v("我已知晓")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "info-section" }, [
                    _c(
                      "div",
                      { staticClass: "info-item" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("标签"),
                        ]),
                        _vm.detail.tag
                          ? _c(
                              "el-tag",
                              {
                                style: _vm.tagStyle(_vm.detail.tag.color),
                                attrs: { size: "small" },
                              },
                              [_vm._v(_vm._s(_vm.detail.tag.name))]
                            )
                          : _c("span", { staticClass: "info-value" }, [
                              _vm._v("-"),
                            ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("发布时间"),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.detail.audit_time || "-")),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("发布人"),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.detail.creator_name || "-")),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "content-section" }, [
                    _c("div", {
                      staticClass: "content-body",
                      domProps: { innerHTML: _vm._s(_vm.detail.content) },
                    }),
                  ]),
                  _vm.detail.attachments && _vm.detail.attachments.length
                    ? _c(
                        "div",
                        { staticClass: "attachment-section" },
                        _vm._l(_vm.detail.attachments, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: item.name + "-" + index,
                              staticClass: "attachment-item",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "attachment-name",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePreview(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _vm._v(" " + _vm._s(item.name) + " "),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "attachment-download",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDownload(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-download" }),
                                  _vm._v(" 下载 "),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              : !_vm.detailLoading
              ? _c("div", { staticClass: "pane-empty" }, [
                  _c("img", {
                    staticClass: "pane-empty__img",
                    attrs: {
                      src: require("@/assets/img/em.png"),
                      alt: "暂无公告",
                    },
                  }),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "callback-info" }, [
      _c("i", { staticClass: "el-icon-warning" }),
      _c("div", { staticClass: "callback-text" }, [
        _c("div", { staticClass: "callback-title" }, [
          _vm._v("请阅读公告并完成回执"),
        ]),
        _c("div", { staticClass: "callback-tip" }, [
          _vm._v("阅读后请点击「我已知晓」完成回执"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }